/* tslint:disable */
/* eslint-disable */
/**
 * mindd-qx-deliveries
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddressUpdateRequestDto } from '../model';
// @ts-ignore
import type { CancelDto } from '../model';
// @ts-ignore
import type { CancelRegistrationDto } from '../model';
// @ts-ignore
import type { DeliveryCreateDto } from '../model';
// @ts-ignore
import type { DeliveryReadyForShipDto } from '../model';
// @ts-ignore
import type { DeliveryRegisterShipmentDto } from '../model';
// @ts-ignore
import type { DeliverySummaryDto } from '../model';
// @ts-ignore
import type { PrescriptionDeliveryView } from '../model';
// @ts-ignore
import type { PrintUriRequestDto } from '../model';
// @ts-ignore
import type { ReplaceDeviceDto } from '../model';
// @ts-ignore
import type { ReturnCompleteRequestDto } from '../model';
// @ts-ignore
import type { ReturnHoldDetailDto } from '../model';
// @ts-ignore
import type { ReturnHoldRequestDto } from '../model';
// @ts-ignore
import type { StartExchangeRequestDto } from '../model';
/**
 * DeliveryControllerApi - axios parameter creator
 * @export
 */
export const DeliveryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 주문 취소
         * @param {CancelDto} cancelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (cancelDto: CancelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelDto' is not null or undefined
            assertParamExists('cancel', 'cancelDto', cancelDto)
            const localVarPath = `/deliveries/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 발송 준비 상태를 취소합니다.(기기 ID 제거)
         * @summary 발송 준비 취소
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelReadyToShip: async (deliveryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('cancelReadyToShip', 'deliveryId', deliveryId)
            const localVarPath = `/deliveries/ready-to-ship/{deliveryId}/cancel`
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 배송 접수 취소
         * @summary 배송 접수 취소
         * @param {CancelRegistrationDto} cancelRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRegisterShipment: async (cancelRegistrationDto: CancelRegistrationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelRegistrationDto' is not null or undefined
            assertParamExists('cancelRegisterShipment', 'cancelRegistrationDto', cancelRegistrationDto)
            const localVarPath = `/deliveries/register-shipment/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelRegistrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 물류센터 검수 통과 시 회수건을 반납완료로 종결
         * @summary 반납완료 처리(와이브레인)
         * @param {ReturnCompleteRequestDto} returnCompleteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeReturn1: async (returnCompleteRequestDto: ReturnCompleteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnCompleteRequestDto' is not null or undefined
            assertParamExists('completeReturn1', 'returnCompleteRequestDto', returnCompleteRequestDto)
            const localVarPath = `/deliveries/return/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnCompleteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 각 제품 서버에서 access_key/secret_key 로 호출. 사용자 정보를 body 로 전달
         * @summary 배송건 생성 (M2M)
         * @param {DeliveryCreateDto} deliveryCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDelivery: async (deliveryCreateDto: DeliveryCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryCreateDto' is not null or undefined
            assertParamExists('createDelivery', 'deliveryCreateDto', deliveryCreateDto)
            const localVarPath = `/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 다양한 필터 조건으로 배송 목록을 조회합니다. 병원 토큰일 경우 병원의 배송만, 환자 토큰일 경우 환자의 배송만 조회합니다. 병원이 Ybrain이면 전체 조회합니다. 날짜 필터(dateFrom/dateTo)는 카테고리별 기준 필드가 다릅니다 — 배송/반납=생성일, 교환=교환 전환일, 취소=취소 전환일. dateBasis=CREATED_TIME 을 주면 타입 무관하게 전 건을 생성일(createdTime) 기준으로 통일 조회합니다.
         * @summary 배송 목록 조회
         * @param {string} [deliveryId] 
         * @param {number} [deviceId] 
         * @param {string} [invoiceNo] 
         * @param {Array<FindAllStatusesEnum>} [statuses] 
         * @param {string} [dateFrom] 조회 기준 날짜 시작. 배송/반납&#x3D;생성일, 교환&#x3D;교환 전환일, 취소&#x3D;취소 전환일
         * @param {string} [dateTo] 조회 기준 날짜 종료. dateFrom 과 동일 기준
         * @param {FindAllDateBasisEnum} [dateBasis] 날짜 필터 기준. TYPE_SPECIFIC(기본)&#x3D;타입별 기준일, CREATED_TIME&#x3D;전 타입 생성일 통일
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [includeCompleted] 기본 false면 종료 상태(배송완료·반납완료·취소완료·교환완료·사용완료) 제외. 취소/교환을 날짜로 조회 시 완료 건(CANCEL_COMPLETED/EXCHANGE_COMPLETED)이 숨겨지므로 완료 건까지 보려면 true 필요. statuses에 종료 상태를 명시하면서 false로 두면 결과가 항상 비므로 주의.
         * @param {Array<FindAllDeliveryTypesEnum>} [deliveryTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (deliveryId?: string, deviceId?: number, invoiceNo?: string, statuses?: Array<FindAllStatusesEnum>, dateFrom?: string, dateTo?: string, dateBasis?: FindAllDateBasisEnum, includeDeleted?: boolean, includeCompleted?: boolean, deliveryTypes?: Array<FindAllDeliveryTypesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deliveryId !== undefined) {
                localVarQueryParameter['deliveryId'] = deliveryId;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (invoiceNo !== undefined) {
                localVarQueryParameter['invoiceNo'] = invoiceNo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (dateBasis !== undefined) {
                localVarQueryParameter['dateBasis'] = dateBasis;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['includeCompleted'] = includeCompleted;
            }

            if (deliveryTypes) {
                localVarQueryParameter['deliveryTypes'] = deliveryTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 토큰이 가리키는 배송건을 조회
         * @summary 배송 조회(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findMyDeliveries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliveries/my-delivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 반납 예상 시각이 지났으나 아직 반납 요청을 하지 않은 배송건(DELIVERED) 목록. 병원 토큰이면 해당 병원, 환자 토큰이면 본인, Ybrain이면 전체를 조회합니다. dateFrom/dateTo는 반납 예상 시각(expectedReturnRequestDate) 기준이며, 항상 \'현재 시각 이전(연체)\' 조건이 함께 적용됩니다 — dateTo를 미래로 줘도 아직 연체가 아닌 건은 조회되지 않습니다. 두 파라미터를 모두 생략하면 기존과 동일하게 \'현재 연체 전체\'를 반환합니다.
         * @summary 반납 예상 시각 경과 회수 대상 조회
         * @param {string} [dateFrom] 반납 예상 시각 조회 시작(inclusive). 생략 시 하한 없음.
         * @param {string} [dateTo] 반납 예상 시각 조회 종료(inclusive). 항상 현재 시각 이전 조건과 AND 적용되어 미래값을 줘도 연체 건만 조회됨.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOverdueReturns: async (dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliveries/overdue-returns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자 앱 메인 화면이 처방 하나를 그리는 데 필요한 배송 정보를 한 번에 조회합니다. headline 은 헤드라인 문구를 고를 대표 배송건이며 응답이 있으면 항상 존재합니다. deviceUsable 이 true 면 headline 이 지금 치료에 쓸 수 있는 기기이며 반납 요청 대상입니다. inProgress 는 상태 칩으로 그릴 진행 중인 배송·회수 건입니다. 그 처방에 배송건이 없거나 본인 처방이 아니면 404 이며 두 경우를 구별할 수 없습니다.
         * @summary 처방 단위 배송 조회(환자 토큰 필요)
         * @param {string} prescriptionId 조회할 처방
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrescriptionDeliveryView: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findPrescriptionDeliveryView', 'prescriptionId', prescriptionId)
            const localVarPath = `/deliveries/me/prescriptions/{prescriptionId}`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * replace-device 가 교체할 배송건을 부작용 없이 미리 조회한다. 후보 1건이면 반환, 0건이면 404, 다건(데이터 이상)이면 409. 비-Ybrain 은 자기 org 만 조회.
         * @summary 교체 대상 배송건 조회(병원/Ybrain)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReplaceable: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findReplaceable', 'prescriptionId', prescriptionId)
            const localVarPath = `/deliveries/replaceable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (prescriptionId !== undefined) {
                localVarQueryParameter['prescriptionId'] = prescriptionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 회수 건의 반납보류 상세(문제 구성품 + 사유)를 최신순으로 조회
         * @summary 반납보류 상세 조회(와이브레인)
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReturnHoldDetails: async (deliveryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('findReturnHoldDetails', 'deliveryId', deliveryId)
            const localVarPath = `/deliveries/return/hold/{deliveryId}`
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 송장 출력 URI를 통해 송장 출력, 송장 출력시 운송장 번호 발급됨
         * @summary 송장 출력 URI 조회
         * @param {PrintUriRequestDto} printUriRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingLabelPrintUri: async (printUriRequestDto: PrintUriRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'printUriRequestDto' is not null or undefined
            assertParamExists('getShippingLabelPrintUri', 'printUriRequestDto', printUriRequestDto)
            const localVarPath = `/deliveries/print-uri`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printUriRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 물류센터 검수 중 문제 발생 시 회수건을 반납보류로 전환. 문제 구성품과 사유는 필수.
         * @summary 반납보류 처리(와이브레인)
         * @param {ReturnHoldRequestDto} returnHoldRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        holdReturn: async (returnHoldRequestDto: ReturnHoldRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnHoldRequestDto' is not null or undefined
            assertParamExists('holdReturn', 'returnHoldRequestDto', returnHoldRequestDto)
            const localVarPath = `/deliveries/return/hold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnHoldRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 기기 준비 및 포장, QR출력 등..
         * @summary 발송 준비
         * @param {string} deliveryId 
         * @param {DeliveryReadyForShipDto} deliveryReadyForShipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyToShip1: async (deliveryId: string, deliveryReadyForShipDto: DeliveryReadyForShipDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('readyToShip1', 'deliveryId', deliveryId)
            // verify required parameter 'deliveryReadyForShipDto' is not null or undefined
            assertParamExists('readyToShip1', 'deliveryReadyForShipDto', deliveryReadyForShipDto)
            const localVarPath = `/deliveries/ready-to-ship/{deliveryId}`
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryReadyForShipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 택배사에 배송 주문 접수, serviceId 발급됨
         * @summary 주문 접수 요청
         * @param {DeliveryRegisterShipmentDto} deliveryRegisterShipmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerShipment: async (deliveryRegisterShipmentDto: DeliveryRegisterShipmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryRegisterShipmentDto' is not null or undefined
            assertParamExists('registerShipment', 'deliveryRegisterShipmentDto', deliveryRegisterShipmentDto)
            const localVarPath = `/deliveries/register-shipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryRegisterShipmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 배송완료 상태에서 물리적 기기 교체 시 deviceId 를 갱신한다. stim3-home 이 M2M 으로 호출한다.
         * @summary 기기 교체(직접 교환, M2M)
         * @param {ReplaceDeviceDto} replaceDeviceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDevice: async (replaceDeviceDto: ReplaceDeviceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'replaceDeviceDto' is not null or undefined
            assertParamExists('replaceDevice', 'replaceDeviceDto', replaceDeviceDto)
            const localVarPath = `/deliveries/replace-device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceDeviceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 기기 사용 완료 후 회수 요청. 회수취소된 건이면 재신청으로 처리
         * @summary 회수 요청/재신청(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        requestReturn: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliveries/return/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 기기 사용자가 주소 입력 후 배송 요청
         * @summary 배송 요청(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        requested: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliveries/requested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 배송 요청 알림톡을 다시 발송합니다. PENDING 상태가 아니거나 일반 배송건(SHIPMENT)이 아니면 409(REQUEST_MESSAGE_NOT_RESENDABLE)로 거절하며, reasonCode 로 사유를 구분합니다(NOT_PENDING / NOT_PLAIN_SHIPMENT).
         * @summary 배송 요청 알림톡 재발송
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendRequestMessage: async (deliveryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('resendRequestMessage', 'deliveryId', deliveryId)
            const localVarPath = `/deliveries/{deliveryId}/resend-request-message`
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 물류센터에서 교환을 시작. 회수건과 신규 배송건이 각각 생성되고 원본이 EXCHANGING 으로 전환됨
         * @summary 교환 시작(물류센터 토큰 필요)
         * @param {StartExchangeRequestDto} startExchangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExchange: async (startExchangeRequestDto: StartExchangeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startExchangeRequestDto' is not null or undefined
            assertParamExists('startExchange', 'startExchangeRequestDto', startExchangeRequestDto)
            const localVarPath = `/deliveries/exchange/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startExchangeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 배송지 변경
         * @summary 배송지 변경
         * @param {string} deliveryId 
         * @param {AddressUpdateRequestDto} addressUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAddress: async (deliveryId: string, addressUpdateRequestDto: AddressUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryId' is not null or undefined
            assertParamExists('updateShippingAddress', 'deliveryId', deliveryId)
            // verify required parameter 'addressUpdateRequestDto' is not null or undefined
            assertParamExists('updateShippingAddress', 'addressUpdateRequestDto', addressUpdateRequestDto)
            const localVarPath = `/deliveries/{deliveryId}/shipping-address/`
                .replace(`{${"deliveryId"}}`, encodeURIComponent(String(deliveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryControllerApi - functional programming interface
 * @export
 */
export const DeliveryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 주문 취소
         * @param {CancelDto} cancelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(cancelDto: CancelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliverySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(cancelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 발송 준비 상태를 취소합니다.(기기 ID 제거)
         * @summary 발송 준비 취소
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelReadyToShip(deliveryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelReadyToShip(deliveryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.cancelReadyToShip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 배송 접수 취소
         * @summary 배송 접수 취소
         * @param {CancelRegistrationDto} cancelRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRegisterShipment(cancelRegistrationDto: CancelRegistrationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliverySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRegisterShipment(cancelRegistrationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.cancelRegisterShipment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 물류센터 검수 통과 시 회수건을 반납완료로 종결
         * @summary 반납완료 처리(와이브레인)
         * @param {ReturnCompleteRequestDto} returnCompleteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeReturn1(returnCompleteRequestDto: ReturnCompleteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeReturn1(returnCompleteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.completeReturn1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 각 제품 서버에서 access_key/secret_key 로 호출. 사용자 정보를 body 로 전달
         * @summary 배송건 생성 (M2M)
         * @param {DeliveryCreateDto} deliveryCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDelivery(deliveryCreateDto: DeliveryCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDelivery(deliveryCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.createDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 다양한 필터 조건으로 배송 목록을 조회합니다. 병원 토큰일 경우 병원의 배송만, 환자 토큰일 경우 환자의 배송만 조회합니다. 병원이 Ybrain이면 전체 조회합니다. 날짜 필터(dateFrom/dateTo)는 카테고리별 기준 필드가 다릅니다 — 배송/반납=생성일, 교환=교환 전환일, 취소=취소 전환일. dateBasis=CREATED_TIME 을 주면 타입 무관하게 전 건을 생성일(createdTime) 기준으로 통일 조회합니다.
         * @summary 배송 목록 조회
         * @param {string} [deliveryId] 
         * @param {number} [deviceId] 
         * @param {string} [invoiceNo] 
         * @param {Array<FindAllStatusesEnum>} [statuses] 
         * @param {string} [dateFrom] 조회 기준 날짜 시작. 배송/반납&#x3D;생성일, 교환&#x3D;교환 전환일, 취소&#x3D;취소 전환일
         * @param {string} [dateTo] 조회 기준 날짜 종료. dateFrom 과 동일 기준
         * @param {FindAllDateBasisEnum} [dateBasis] 날짜 필터 기준. TYPE_SPECIFIC(기본)&#x3D;타입별 기준일, CREATED_TIME&#x3D;전 타입 생성일 통일
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [includeCompleted] 기본 false면 종료 상태(배송완료·반납완료·취소완료·교환완료·사용완료) 제외. 취소/교환을 날짜로 조회 시 완료 건(CANCEL_COMPLETED/EXCHANGE_COMPLETED)이 숨겨지므로 완료 건까지 보려면 true 필요. statuses에 종료 상태를 명시하면서 false로 두면 결과가 항상 비므로 주의.
         * @param {Array<FindAllDeliveryTypesEnum>} [deliveryTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(deliveryId?: string, deviceId?: number, invoiceNo?: string, statuses?: Array<FindAllStatusesEnum>, dateFrom?: string, dateTo?: string, dateBasis?: FindAllDateBasisEnum, includeDeleted?: boolean, includeCompleted?: boolean, deliveryTypes?: Array<FindAllDeliveryTypesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliverySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(deliveryId, deviceId, invoiceNo, statuses, dateFrom, dateTo, dateBasis, includeDeleted, includeCompleted, deliveryTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.findAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 토큰이 가리키는 배송건을 조회
         * @summary 배송 조회(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findMyDeliveries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyDeliveries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.findMyDeliveries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 반납 예상 시각이 지났으나 아직 반납 요청을 하지 않은 배송건(DELIVERED) 목록. 병원 토큰이면 해당 병원, 환자 토큰이면 본인, Ybrain이면 전체를 조회합니다. dateFrom/dateTo는 반납 예상 시각(expectedReturnRequestDate) 기준이며, 항상 \'현재 시각 이전(연체)\' 조건이 함께 적용됩니다 — dateTo를 미래로 줘도 아직 연체가 아닌 건은 조회되지 않습니다. 두 파라미터를 모두 생략하면 기존과 동일하게 \'현재 연체 전체\'를 반환합니다.
         * @summary 반납 예상 시각 경과 회수 대상 조회
         * @param {string} [dateFrom] 반납 예상 시각 조회 시작(inclusive). 생략 시 하한 없음.
         * @param {string} [dateTo] 반납 예상 시각 조회 종료(inclusive). 항상 현재 시각 이전 조건과 AND 적용되어 미래값을 줘도 연체 건만 조회됨.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOverdueReturns(dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliverySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOverdueReturns(dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.findOverdueReturns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자 앱 메인 화면이 처방 하나를 그리는 데 필요한 배송 정보를 한 번에 조회합니다. headline 은 헤드라인 문구를 고를 대표 배송건이며 응답이 있으면 항상 존재합니다. deviceUsable 이 true 면 headline 이 지금 치료에 쓸 수 있는 기기이며 반납 요청 대상입니다. inProgress 는 상태 칩으로 그릴 진행 중인 배송·회수 건입니다. 그 처방에 배송건이 없거나 본인 처방이 아니면 404 이며 두 경우를 구별할 수 없습니다.
         * @summary 처방 단위 배송 조회(환자 토큰 필요)
         * @param {string} prescriptionId 조회할 처방
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPrescriptionDeliveryView(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrescriptionDeliveryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPrescriptionDeliveryView(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.findPrescriptionDeliveryView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * replace-device 가 교체할 배송건을 부작용 없이 미리 조회한다. 후보 1건이면 반환, 0건이면 404, 다건(데이터 이상)이면 409. 비-Ybrain 은 자기 org 만 조회.
         * @summary 교체 대상 배송건 조회(병원/Ybrain)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReplaceable(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findReplaceable(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.findReplaceable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 회수 건의 반납보류 상세(문제 구성품 + 사유)를 최신순으로 조회
         * @summary 반납보류 상세 조회(와이브레인)
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReturnHoldDetails(deliveryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReturnHoldDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findReturnHoldDetails(deliveryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.findReturnHoldDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 송장 출력 URI를 통해 송장 출력, 송장 출력시 운송장 번호 발급됨
         * @summary 송장 출력 URI 조회
         * @param {PrintUriRequestDto} printUriRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShippingLabelPrintUri(printUriRequestDto: PrintUriRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShippingLabelPrintUri(printUriRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.getShippingLabelPrintUri']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 물류센터 검수 중 문제 발생 시 회수건을 반납보류로 전환. 문제 구성품과 사유는 필수.
         * @summary 반납보류 처리(와이브레인)
         * @param {ReturnHoldRequestDto} returnHoldRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async holdReturn(returnHoldRequestDto: ReturnHoldRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.holdReturn(returnHoldRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.holdReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 기기 준비 및 포장, QR출력 등..
         * @summary 발송 준비
         * @param {string} deliveryId 
         * @param {DeliveryReadyForShipDto} deliveryReadyForShipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readyToShip1(deliveryId: string, deliveryReadyForShipDto: DeliveryReadyForShipDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readyToShip1(deliveryId, deliveryReadyForShipDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.readyToShip1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 택배사에 배송 주문 접수, serviceId 발급됨
         * @summary 주문 접수 요청
         * @param {DeliveryRegisterShipmentDto} deliveryRegisterShipmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerShipment(deliveryRegisterShipmentDto: DeliveryRegisterShipmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliverySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerShipment(deliveryRegisterShipmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.registerShipment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 배송완료 상태에서 물리적 기기 교체 시 deviceId 를 갱신한다. stim3-home 이 M2M 으로 호출한다.
         * @summary 기기 교체(직접 교환, M2M)
         * @param {ReplaceDeviceDto} replaceDeviceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceDevice(replaceDeviceDto: ReplaceDeviceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceDevice(replaceDeviceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.replaceDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 기기 사용 완료 후 회수 요청. 회수취소된 건이면 재신청으로 처리
         * @summary 회수 요청/재신청(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async requestReturn(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestReturn(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.requestReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 기기 사용자가 주소 입력 후 배송 요청
         * @summary 배송 요청(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async requested(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requested(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.requested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 배송 요청 알림톡을 다시 발송합니다. PENDING 상태가 아니거나 일반 배송건(SHIPMENT)이 아니면 409(REQUEST_MESSAGE_NOT_RESENDABLE)로 거절하며, reasonCode 로 사유를 구분합니다(NOT_PENDING / NOT_PLAIN_SHIPMENT).
         * @summary 배송 요청 알림톡 재발송
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendRequestMessage(deliveryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendRequestMessage(deliveryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.resendRequestMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 물류센터에서 교환을 시작. 회수건과 신규 배송건이 각각 생성되고 원본이 EXCHANGING 으로 전환됨
         * @summary 교환 시작(물류센터 토큰 필요)
         * @param {StartExchangeRequestDto} startExchangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startExchange(startExchangeRequestDto: StartExchangeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startExchange(startExchangeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.startExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 배송지 변경
         * @summary 배송지 변경
         * @param {string} deliveryId 
         * @param {AddressUpdateRequestDto} addressUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShippingAddress(deliveryId: string, addressUpdateRequestDto: AddressUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShippingAddress(deliveryId, addressUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryControllerApi.updateShippingAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveryControllerApi - factory interface
 * @export
 */
export const DeliveryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 주문 취소
         * @param {CancelDto} cancelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(cancelDto: CancelDto, options?: any): AxiosPromise<Array<DeliverySummaryDto>> {
            return localVarFp.cancel(cancelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 발송 준비 상태를 취소합니다.(기기 ID 제거)
         * @summary 발송 준비 취소
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelReadyToShip(deliveryId: string, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.cancelReadyToShip(deliveryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 배송 접수 취소
         * @summary 배송 접수 취소
         * @param {CancelRegistrationDto} cancelRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRegisterShipment(cancelRegistrationDto: CancelRegistrationDto, options?: any): AxiosPromise<Array<DeliverySummaryDto>> {
            return localVarFp.cancelRegisterShipment(cancelRegistrationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 물류센터 검수 통과 시 회수건을 반납완료로 종결
         * @summary 반납완료 처리(와이브레인)
         * @param {ReturnCompleteRequestDto} returnCompleteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeReturn1(returnCompleteRequestDto: ReturnCompleteRequestDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.completeReturn1(returnCompleteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 각 제품 서버에서 access_key/secret_key 로 호출. 사용자 정보를 body 로 전달
         * @summary 배송건 생성 (M2M)
         * @param {DeliveryCreateDto} deliveryCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDelivery(deliveryCreateDto: DeliveryCreateDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.createDelivery(deliveryCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 다양한 필터 조건으로 배송 목록을 조회합니다. 병원 토큰일 경우 병원의 배송만, 환자 토큰일 경우 환자의 배송만 조회합니다. 병원이 Ybrain이면 전체 조회합니다. 날짜 필터(dateFrom/dateTo)는 카테고리별 기준 필드가 다릅니다 — 배송/반납=생성일, 교환=교환 전환일, 취소=취소 전환일. dateBasis=CREATED_TIME 을 주면 타입 무관하게 전 건을 생성일(createdTime) 기준으로 통일 조회합니다.
         * @summary 배송 목록 조회
         * @param {string} [deliveryId] 
         * @param {number} [deviceId] 
         * @param {string} [invoiceNo] 
         * @param {Array<FindAllStatusesEnum>} [statuses] 
         * @param {string} [dateFrom] 조회 기준 날짜 시작. 배송/반납&#x3D;생성일, 교환&#x3D;교환 전환일, 취소&#x3D;취소 전환일
         * @param {string} [dateTo] 조회 기준 날짜 종료. dateFrom 과 동일 기준
         * @param {FindAllDateBasisEnum} [dateBasis] 날짜 필터 기준. TYPE_SPECIFIC(기본)&#x3D;타입별 기준일, CREATED_TIME&#x3D;전 타입 생성일 통일
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [includeCompleted] 기본 false면 종료 상태(배송완료·반납완료·취소완료·교환완료·사용완료) 제외. 취소/교환을 날짜로 조회 시 완료 건(CANCEL_COMPLETED/EXCHANGE_COMPLETED)이 숨겨지므로 완료 건까지 보려면 true 필요. statuses에 종료 상태를 명시하면서 false로 두면 결과가 항상 비므로 주의.
         * @param {Array<FindAllDeliveryTypesEnum>} [deliveryTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(deliveryId?: string, deviceId?: number, invoiceNo?: string, statuses?: Array<FindAllStatusesEnum>, dateFrom?: string, dateTo?: string, dateBasis?: FindAllDateBasisEnum, includeDeleted?: boolean, includeCompleted?: boolean, deliveryTypes?: Array<FindAllDeliveryTypesEnum>, options?: any): AxiosPromise<Array<DeliverySummaryDto>> {
            return localVarFp.findAll(deliveryId, deviceId, invoiceNo, statuses, dateFrom, dateTo, dateBasis, includeDeleted, includeCompleted, deliveryTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 토큰이 가리키는 배송건을 조회
         * @summary 배송 조회(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findMyDeliveries(options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.findMyDeliveries(options).then((request) => request(axios, basePath));
        },
        /**
         * 반납 예상 시각이 지났으나 아직 반납 요청을 하지 않은 배송건(DELIVERED) 목록. 병원 토큰이면 해당 병원, 환자 토큰이면 본인, Ybrain이면 전체를 조회합니다. dateFrom/dateTo는 반납 예상 시각(expectedReturnRequestDate) 기준이며, 항상 \'현재 시각 이전(연체)\' 조건이 함께 적용됩니다 — dateTo를 미래로 줘도 아직 연체가 아닌 건은 조회되지 않습니다. 두 파라미터를 모두 생략하면 기존과 동일하게 \'현재 연체 전체\'를 반환합니다.
         * @summary 반납 예상 시각 경과 회수 대상 조회
         * @param {string} [dateFrom] 반납 예상 시각 조회 시작(inclusive). 생략 시 하한 없음.
         * @param {string} [dateTo] 반납 예상 시각 조회 종료(inclusive). 항상 현재 시각 이전 조건과 AND 적용되어 미래값을 줘도 연체 건만 조회됨.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOverdueReturns(dateFrom?: string, dateTo?: string, options?: any): AxiosPromise<Array<DeliverySummaryDto>> {
            return localVarFp.findOverdueReturns(dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자 앱 메인 화면이 처방 하나를 그리는 데 필요한 배송 정보를 한 번에 조회합니다. headline 은 헤드라인 문구를 고를 대표 배송건이며 응답이 있으면 항상 존재합니다. deviceUsable 이 true 면 headline 이 지금 치료에 쓸 수 있는 기기이며 반납 요청 대상입니다. inProgress 는 상태 칩으로 그릴 진행 중인 배송·회수 건입니다. 그 처방에 배송건이 없거나 본인 처방이 아니면 404 이며 두 경우를 구별할 수 없습니다.
         * @summary 처방 단위 배송 조회(환자 토큰 필요)
         * @param {string} prescriptionId 조회할 처방
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrescriptionDeliveryView(prescriptionId: string, options?: any): AxiosPromise<PrescriptionDeliveryView> {
            return localVarFp.findPrescriptionDeliveryView(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * replace-device 가 교체할 배송건을 부작용 없이 미리 조회한다. 후보 1건이면 반환, 0건이면 404, 다건(데이터 이상)이면 409. 비-Ybrain 은 자기 org 만 조회.
         * @summary 교체 대상 배송건 조회(병원/Ybrain)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReplaceable(prescriptionId: string, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.findReplaceable(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 회수 건의 반납보류 상세(문제 구성품 + 사유)를 최신순으로 조회
         * @summary 반납보류 상세 조회(와이브레인)
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReturnHoldDetails(deliveryId: string, options?: any): AxiosPromise<Array<ReturnHoldDetailDto>> {
            return localVarFp.findReturnHoldDetails(deliveryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 송장 출력 URI를 통해 송장 출력, 송장 출력시 운송장 번호 발급됨
         * @summary 송장 출력 URI 조회
         * @param {PrintUriRequestDto} printUriRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingLabelPrintUri(printUriRequestDto: PrintUriRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.getShippingLabelPrintUri(printUriRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 물류센터 검수 중 문제 발생 시 회수건을 반납보류로 전환. 문제 구성품과 사유는 필수.
         * @summary 반납보류 처리(와이브레인)
         * @param {ReturnHoldRequestDto} returnHoldRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        holdReturn(returnHoldRequestDto: ReturnHoldRequestDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.holdReturn(returnHoldRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 기기 준비 및 포장, QR출력 등..
         * @summary 발송 준비
         * @param {string} deliveryId 
         * @param {DeliveryReadyForShipDto} deliveryReadyForShipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyToShip1(deliveryId: string, deliveryReadyForShipDto: DeliveryReadyForShipDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.readyToShip1(deliveryId, deliveryReadyForShipDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 택배사에 배송 주문 접수, serviceId 발급됨
         * @summary 주문 접수 요청
         * @param {DeliveryRegisterShipmentDto} deliveryRegisterShipmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerShipment(deliveryRegisterShipmentDto: DeliveryRegisterShipmentDto, options?: any): AxiosPromise<Array<DeliverySummaryDto>> {
            return localVarFp.registerShipment(deliveryRegisterShipmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 배송완료 상태에서 물리적 기기 교체 시 deviceId 를 갱신한다. stim3-home 이 M2M 으로 호출한다.
         * @summary 기기 교체(직접 교환, M2M)
         * @param {ReplaceDeviceDto} replaceDeviceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDevice(replaceDeviceDto: ReplaceDeviceDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.replaceDevice(replaceDeviceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 기기 사용 완료 후 회수 요청. 회수취소된 건이면 재신청으로 처리
         * @summary 회수 요청/재신청(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        requestReturn(options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.requestReturn(options).then((request) => request(axios, basePath));
        },
        /**
         * 기기 사용자가 주소 입력 후 배송 요청
         * @summary 배송 요청(옛 배송 링크 토큰 필요)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        requested(options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.requested(options).then((request) => request(axios, basePath));
        },
        /**
         * 배송 요청 알림톡을 다시 발송합니다. PENDING 상태가 아니거나 일반 배송건(SHIPMENT)이 아니면 409(REQUEST_MESSAGE_NOT_RESENDABLE)로 거절하며, reasonCode 로 사유를 구분합니다(NOT_PENDING / NOT_PLAIN_SHIPMENT).
         * @summary 배송 요청 알림톡 재발송
         * @param {string} deliveryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendRequestMessage(deliveryId: string, options?: any): AxiosPromise<void> {
            return localVarFp.resendRequestMessage(deliveryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 물류센터에서 교환을 시작. 회수건과 신규 배송건이 각각 생성되고 원본이 EXCHANGING 으로 전환됨
         * @summary 교환 시작(물류센터 토큰 필요)
         * @param {StartExchangeRequestDto} startExchangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExchange(startExchangeRequestDto: StartExchangeRequestDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.startExchange(startExchangeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 배송지 변경
         * @summary 배송지 변경
         * @param {string} deliveryId 
         * @param {AddressUpdateRequestDto} addressUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAddress(deliveryId: string, addressUpdateRequestDto: AddressUpdateRequestDto, options?: any): AxiosPromise<DeliverySummaryDto> {
            return localVarFp.updateShippingAddress(deliveryId, addressUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryControllerApi - object-oriented interface
 * @export
 * @class DeliveryControllerApi
 * @extends {BaseAPI}
 */
export class DeliveryControllerApi extends BaseAPI {
    /**
     * 
     * @summary 주문 취소
     * @param {CancelDto} cancelDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public cancel(cancelDto: CancelDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).cancel(cancelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 발송 준비 상태를 취소합니다.(기기 ID 제거)
     * @summary 발송 준비 취소
     * @param {string} deliveryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public cancelReadyToShip(deliveryId: string, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).cancelReadyToShip(deliveryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 배송 접수 취소
     * @summary 배송 접수 취소
     * @param {CancelRegistrationDto} cancelRegistrationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public cancelRegisterShipment(cancelRegistrationDto: CancelRegistrationDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).cancelRegisterShipment(cancelRegistrationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 물류센터 검수 통과 시 회수건을 반납완료로 종결
     * @summary 반납완료 처리(와이브레인)
     * @param {ReturnCompleteRequestDto} returnCompleteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public completeReturn1(returnCompleteRequestDto: ReturnCompleteRequestDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).completeReturn1(returnCompleteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 각 제품 서버에서 access_key/secret_key 로 호출. 사용자 정보를 body 로 전달
     * @summary 배송건 생성 (M2M)
     * @param {DeliveryCreateDto} deliveryCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public createDelivery(deliveryCreateDto: DeliveryCreateDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).createDelivery(deliveryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 다양한 필터 조건으로 배송 목록을 조회합니다. 병원 토큰일 경우 병원의 배송만, 환자 토큰일 경우 환자의 배송만 조회합니다. 병원이 Ybrain이면 전체 조회합니다. 날짜 필터(dateFrom/dateTo)는 카테고리별 기준 필드가 다릅니다 — 배송/반납=생성일, 교환=교환 전환일, 취소=취소 전환일. dateBasis=CREATED_TIME 을 주면 타입 무관하게 전 건을 생성일(createdTime) 기준으로 통일 조회합니다.
     * @summary 배송 목록 조회
     * @param {string} [deliveryId] 
     * @param {number} [deviceId] 
     * @param {string} [invoiceNo] 
     * @param {Array<FindAllStatusesEnum>} [statuses] 
     * @param {string} [dateFrom] 조회 기준 날짜 시작. 배송/반납&#x3D;생성일, 교환&#x3D;교환 전환일, 취소&#x3D;취소 전환일
     * @param {string} [dateTo] 조회 기준 날짜 종료. dateFrom 과 동일 기준
     * @param {FindAllDateBasisEnum} [dateBasis] 날짜 필터 기준. TYPE_SPECIFIC(기본)&#x3D;타입별 기준일, CREATED_TIME&#x3D;전 타입 생성일 통일
     * @param {boolean} [includeDeleted] 
     * @param {boolean} [includeCompleted] 기본 false면 종료 상태(배송완료·반납완료·취소완료·교환완료·사용완료) 제외. 취소/교환을 날짜로 조회 시 완료 건(CANCEL_COMPLETED/EXCHANGE_COMPLETED)이 숨겨지므로 완료 건까지 보려면 true 필요. statuses에 종료 상태를 명시하면서 false로 두면 결과가 항상 비므로 주의.
     * @param {Array<FindAllDeliveryTypesEnum>} [deliveryTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public findAll(deliveryId?: string, deviceId?: number, invoiceNo?: string, statuses?: Array<FindAllStatusesEnum>, dateFrom?: string, dateTo?: string, dateBasis?: FindAllDateBasisEnum, includeDeleted?: boolean, includeCompleted?: boolean, deliveryTypes?: Array<FindAllDeliveryTypesEnum>, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).findAll(deliveryId, deviceId, invoiceNo, statuses, dateFrom, dateTo, dateBasis, includeDeleted, includeCompleted, deliveryTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 토큰이 가리키는 배송건을 조회
     * @summary 배송 조회(옛 배송 링크 토큰 필요)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public findMyDeliveries(options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).findMyDeliveries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 반납 예상 시각이 지났으나 아직 반납 요청을 하지 않은 배송건(DELIVERED) 목록. 병원 토큰이면 해당 병원, 환자 토큰이면 본인, Ybrain이면 전체를 조회합니다. dateFrom/dateTo는 반납 예상 시각(expectedReturnRequestDate) 기준이며, 항상 \'현재 시각 이전(연체)\' 조건이 함께 적용됩니다 — dateTo를 미래로 줘도 아직 연체가 아닌 건은 조회되지 않습니다. 두 파라미터를 모두 생략하면 기존과 동일하게 \'현재 연체 전체\'를 반환합니다.
     * @summary 반납 예상 시각 경과 회수 대상 조회
     * @param {string} [dateFrom] 반납 예상 시각 조회 시작(inclusive). 생략 시 하한 없음.
     * @param {string} [dateTo] 반납 예상 시각 조회 종료(inclusive). 항상 현재 시각 이전 조건과 AND 적용되어 미래값을 줘도 연체 건만 조회됨.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public findOverdueReturns(dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).findOverdueReturns(dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자 앱 메인 화면이 처방 하나를 그리는 데 필요한 배송 정보를 한 번에 조회합니다. headline 은 헤드라인 문구를 고를 대표 배송건이며 응답이 있으면 항상 존재합니다. deviceUsable 이 true 면 headline 이 지금 치료에 쓸 수 있는 기기이며 반납 요청 대상입니다. inProgress 는 상태 칩으로 그릴 진행 중인 배송·회수 건입니다. 그 처방에 배송건이 없거나 본인 처방이 아니면 404 이며 두 경우를 구별할 수 없습니다.
     * @summary 처방 단위 배송 조회(환자 토큰 필요)
     * @param {string} prescriptionId 조회할 처방
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public findPrescriptionDeliveryView(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).findPrescriptionDeliveryView(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * replace-device 가 교체할 배송건을 부작용 없이 미리 조회한다. 후보 1건이면 반환, 0건이면 404, 다건(데이터 이상)이면 409. 비-Ybrain 은 자기 org 만 조회.
     * @summary 교체 대상 배송건 조회(병원/Ybrain)
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public findReplaceable(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).findReplaceable(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 회수 건의 반납보류 상세(문제 구성품 + 사유)를 최신순으로 조회
     * @summary 반납보류 상세 조회(와이브레인)
     * @param {string} deliveryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public findReturnHoldDetails(deliveryId: string, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).findReturnHoldDetails(deliveryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 송장 출력 URI를 통해 송장 출력, 송장 출력시 운송장 번호 발급됨
     * @summary 송장 출력 URI 조회
     * @param {PrintUriRequestDto} printUriRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public getShippingLabelPrintUri(printUriRequestDto: PrintUriRequestDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).getShippingLabelPrintUri(printUriRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 물류센터 검수 중 문제 발생 시 회수건을 반납보류로 전환. 문제 구성품과 사유는 필수.
     * @summary 반납보류 처리(와이브레인)
     * @param {ReturnHoldRequestDto} returnHoldRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public holdReturn(returnHoldRequestDto: ReturnHoldRequestDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).holdReturn(returnHoldRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 기기 준비 및 포장, QR출력 등..
     * @summary 발송 준비
     * @param {string} deliveryId 
     * @param {DeliveryReadyForShipDto} deliveryReadyForShipDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public readyToShip1(deliveryId: string, deliveryReadyForShipDto: DeliveryReadyForShipDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).readyToShip1(deliveryId, deliveryReadyForShipDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 택배사에 배송 주문 접수, serviceId 발급됨
     * @summary 주문 접수 요청
     * @param {DeliveryRegisterShipmentDto} deliveryRegisterShipmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public registerShipment(deliveryRegisterShipmentDto: DeliveryRegisterShipmentDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).registerShipment(deliveryRegisterShipmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 배송완료 상태에서 물리적 기기 교체 시 deviceId 를 갱신한다. stim3-home 이 M2M 으로 호출한다.
     * @summary 기기 교체(직접 교환, M2M)
     * @param {ReplaceDeviceDto} replaceDeviceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public replaceDevice(replaceDeviceDto: ReplaceDeviceDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).replaceDevice(replaceDeviceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 기기 사용 완료 후 회수 요청. 회수취소된 건이면 재신청으로 처리
     * @summary 회수 요청/재신청(옛 배송 링크 토큰 필요)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public requestReturn(options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).requestReturn(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 기기 사용자가 주소 입력 후 배송 요청
     * @summary 배송 요청(옛 배송 링크 토큰 필요)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public requested(options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).requested(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 배송 요청 알림톡을 다시 발송합니다. PENDING 상태가 아니거나 일반 배송건(SHIPMENT)이 아니면 409(REQUEST_MESSAGE_NOT_RESENDABLE)로 거절하며, reasonCode 로 사유를 구분합니다(NOT_PENDING / NOT_PLAIN_SHIPMENT).
     * @summary 배송 요청 알림톡 재발송
     * @param {string} deliveryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public resendRequestMessage(deliveryId: string, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).resendRequestMessage(deliveryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 물류센터에서 교환을 시작. 회수건과 신규 배송건이 각각 생성되고 원본이 EXCHANGING 으로 전환됨
     * @summary 교환 시작(물류센터 토큰 필요)
     * @param {StartExchangeRequestDto} startExchangeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public startExchange(startExchangeRequestDto: StartExchangeRequestDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).startExchange(startExchangeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 배송지 변경
     * @summary 배송지 변경
     * @param {string} deliveryId 
     * @param {AddressUpdateRequestDto} addressUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryControllerApi
     */
    public updateShippingAddress(deliveryId: string, addressUpdateRequestDto: AddressUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return DeliveryControllerApiFp(this.configuration).updateShippingAddress(deliveryId, addressUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const FindAllStatusesEnum = {
    Pending: 'PENDING',
    Requested: 'REQUESTED',
    ShipmentRegistered: 'SHIPMENT_REGISTERED',
    InvoiceIssued: 'INVOICE_ISSUED',
    Shipped: 'SHIPPED',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Completed: 'COMPLETED',
    ReturnRequested: 'RETURN_REQUESTED',
    ReturnRegistered: 'RETURN_REGISTERED',
    PickupPending: 'PICKUP_PENDING',
    Returning: 'RETURNING',
    Returned: 'RETURNED',
    ReturnCompleted: 'RETURN_COMPLETED',
    ReturnOnHold: 'RETURN_ON_HOLD',
    ReturnAborted: 'RETURN_ABORTED',
    Exchanging: 'EXCHANGING',
    ExchangeCompleted: 'EXCHANGE_COMPLETED',
    OnHold: 'ON_HOLD',
    Canceling: 'CANCELING',
    CancelCompleted: 'CANCEL_COMPLETED'
} as const;
export type FindAllStatusesEnum = typeof FindAllStatusesEnum[keyof typeof FindAllStatusesEnum];
/**
 * @export
 */
export const FindAllDateBasisEnum = {
    TypeSpecific: 'TYPE_SPECIFIC',
    CreatedTime: 'CREATED_TIME'
} as const;
export type FindAllDateBasisEnum = typeof FindAllDateBasisEnum[keyof typeof FindAllDateBasisEnum];
/**
 * @export
 */
export const FindAllDeliveryTypesEnum = {
    Shipment: 'SHIPMENT',
    Return: 'RETURN',
    Cancel: 'CANCEL',
    CancelReturn: 'CANCEL_RETURN',
    Exchange: 'EXCHANGE',
    ExchangeReturn: 'EXCHANGE_RETURN',
    ExchangeShipment: 'EXCHANGE_SHIPMENT'
} as const;
export type FindAllDeliveryTypesEnum = typeof FindAllDeliveryTypesEnum[keyof typeof FindAllDeliveryTypesEnum];
